import React from 'react';
import { SkeletonImage, Space, Skeleton } from '@ag1/ui';
import styles from './SubscriptionCardSkeleton.module.scss';

const SubscriptionCardSkeleton = () => (
  <div className={styles.root}>
    <SkeletonImage aspectRatio={1.5555} className={styles.placeholder} />
    <Space top={20} bottom={20} left={16} right={16}>
      <Skeleton width={80} height={36} />
      <Space top={16}>
        <Skeleton height={40} />
        <div className={styles.fs_20_24}>
          <Space top={8}>
            <Skeleton />
          </Space>
          <Space top={8}>
            <Skeleton />
          </Space>
          <Space top={8}>
            <Skeleton />
          </Space>
        </div>
      </Space>
      <Space top={32}>
        <Skeleton height={44} />
      </Space>
      <Space top={12}>
        <Skeleton height={44} />
      </Space>
    </Space>
  </div>
);

export default SubscriptionCardSkeleton;
